import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import JobCard from "../../../components/jobs/JobCard";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faFolderOpen } from "@fortawesome/free-solid-svg-icons";

const JobTabContent = ({ category, jobs }) => { 
  const { t } = useTranslation();

  // 1. Filtrage préalable pour éviter les calculs dans le JSX
  // On ne garde que les jobs ouverts
  const activeJobs = jobs?.filter(job => !job?.closed) || [];

  // 2. Gestion de l'état vide (Empty State)
  if (activeJobs.length === 0) {
    return (
        <div className="text-center py-5 bg-light rounded-3 mt-4">
            <div className="mb-3 text-muted opacity-50" style={{ fontSize: '3rem' }}>
                <FontAwesomeIcon icon={faFolderOpen} />
            </div>
            <h5 className="text-muted fw-bold">Aucune offre pour le moment</h5>
            <p className="text-muted small">Revenez plus tard ou explorez d'autres catégories.</p>
        </div>
    );
  }

  return (
    <div className="row">
      {activeJobs.slice(0, 8).map((job, index) => (
          <div 
            key={job?.id} 
            className="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12 mb-4 wow animate__animated animate__fadeInUp"
            data-wow-delay={`${index * 0.1}s`} // 3. Animation en cascade (0.1s, 0.2s, etc.)
          >
            <JobCard job={job} />
          </div>
      ))}

      {/* 4. Bouton "Voir plus" en bas de la grille */}
      {activeJobs.length > 0 && (
          <div className="col-12 text-center mt-30">
            <Link 
                to={`/search?industry=${category}`} 
                className="btn btn-primary btn-border-3 fw-bold px-4 py-2"
            >
                {t("ViewMore") || "Voir toutes les offres"}
                <FontAwesomeIcon icon={faArrowRight} className="ms-2" />
            </Link>
          </div>
      )}
    </div>
  );
};

export default JobTabContent;